/**
 * Breakpoint Design Tokens
 *
 * Responsive breakpoints matching MUI's breakpoint system.
 * Used for media queries and responsive design.
 */

export const breakpoints = {
  xs: 375, // Mobile (portrait)
  sm: 640, // Tablet (portrait)
  md: 1024, // Tablet (landscape) / Small desktop
  lg: 1280, // Desktop
  xl: 1561, // Large desktop
} as const

// Breakpoint values as strings (for CSS)
export const breakpointStrings = {
  xs: '375px',
  sm: '640px',
  md: '1024px',
  lg: '1280px',
  xl: '1561px',
} as const
